import type { ButtonHTMLAttributes, ReactNode } from 'react'

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger'
type Size = 'md' | 'sm'

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode
  variant?: Variant
  size?: Size
}) {
  const sizeClass = size === 'sm' ? 'btn-sm' : ''
  const classes = ['btn', `btn-${variant}`, sizeClass, className].filter(Boolean).join(' ')
  return (
    <button {...props} className={classes}>
      {children}
    </button>
  )
}
